import { render, staticRenderFns } from "./table.vue?vue&type=template&id=2bbb4e2c&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb4e2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbb4e2c')) {
      api.createRecord('2bbb4e2c', component.options)
    } else {
      api.reload('2bbb4e2c', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=2bbb4e2c&scoped=true", function () {
      api.rerender('2bbb4e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reports/inbound-texts/messages/table.vue"
export default component.exports